import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Carousel } from "primereact/carousel";
import Media from "../../../components/Media/Media";
import { Button } from "primereact/button";

import { DialogConfirm } from "../../../components/DialogService/DialogService";
import { FooterButtonCenter } from "../../../components/FooterButton/FooterButton";
export default function P206DeletePicList({ dialog, setDialog, searchData, tabCode, dataList, onGenPhotoUpdate }) {

    const [confirmDialog, setConfirmDialog] = useState({ dialog: false, data: {} });
    const onCloseMain = () => {
        setDialog({ ...dialog, dialog: false, show: true });
    };

    const carouselResponsiveOptions = [
        {
            breakpoint: "1024px",
            numVisible: 3,
            numScroll: 3,
        },
        {
            breakpoint: "768px",
            numVisible: 2,
            numScroll: 2,
        },
        {
            breakpoint: "560px",
            numVisible: 1,
            numScroll: 1,
        },
    ];


    const carouselItemTemplate = (data) => {
        return (
            <div className="product-item ">
                <div className="product-item-content" style={{}}>
                    <div className="p-mb-3">
                        <Media
                            path={data.photoPath}
                            alt={data.photoTypeDesc}
                            style={{ width: 200, height: 210 }}
                        // type ={images}
                        />
                    </div>
                    <div>
                        <h6 className="p-mb-2">{data.photoTypeDesc}</h6>
                        {/* <label className="p-mb-1">asd</label> */}
                        <div className="car-buttons p-mt-2">
                            <Button type="button" className="p-button-danger p-button" icon="pi pi-trash"
                                onClick={() => setConfirmDialog({ dialog: true, data })}
                            ></Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };


    const footerButton = () => {
        return <FooterButtonCenter onClickCancle={() => setConfirmDialog({ dialog: false })}
            onClickOk={() => onDelete()}
        />;
    };

    const onDelete = () => {
        onGenPhotoUpdate(confirmDialog.data, "ลบรายการ");
        setConfirmDialog({ dialog: false });
    };


    const renderFooter = () => {
        return (
            <>
                <div className="p-col-12 p-md-12">
                    <div style={{ height: "20px" }} />
                    <div className="p-grid" style={{ textAlign: "center" }}>
                        <div className="p-col-12">
                            
                            <Button
                                className="p-button-danger p-button"
                                icon="pi pi-times"
                                label="ปิดหน้าจอ"
                                // style={{ marginLeft: '5px' }}
                                style={{ width: 200, marginLeft: "5px", marginTop: "10px" }}
                                onClick={() => onCloseMain()}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <Dialog header={"ลบรูปถ่าย"} visible={dialog.dialog} style={{ width: "70vw" }} className="p-fluid" onHide={() => onCloseMain()} blockScroll={true} maximizable={true} footer={renderFooter}>
                <div className="p-grid crud-demo">
                    <div className="p-col-12">
                        <div className="p-grid p-fluid media-demo">
                            <div className="p-col-12">
                                <div className="card">

                                    <div className="p-grid  p-fluid">
                                        {dataList && dataList.length > 0 ?
                                            <div className="p-col-12 p-md-12" style={{ textAlign: 'right' }}>
                                                <label className="">จำนวน {dataList.length} รูปถ่าย</label>
                                            </div>
                                            : ('')
                                        }
                                        <div className="p-col-12 p-md-12">{dataList && dataList.length > 0 ? <Carousel value={dataList} numVisible={4} numScroll={3} responsiveOptions={carouselResponsiveOptions} itemTemplate={carouselItemTemplate}></Carousel> : ""}</div>
                                    </div>
                                    {/* <div className="p-grid  p-fluid">{footer()}</div> */}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Dialog>

            <DialogConfirm
                visible={confirmDialog.dialog}
                header="แจ้งเตือน"
                modal
                footer={footerButton()}
                onHide={() => setConfirmDialog(false)}
                textContent={`คุณต้องการลบข้อมูล ใช่หรือไม่ ?`}
            />
        </>
    );
}
